/**
 * Component: Modal
 * ------------------------------------------------------------------------------
 *
 * @namespace imageSliderModal
 */

import log from 'salvo-lite/log'

import cssClasses from '../helpers/cssClasses'

class ImageSliderModal {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._options = {
            open: '[js-video-modal="open"]',
            close: '[js-video-modal="close"]',
            body: '[js-video-modal="body"]',
            video: '[id="video"]',
            ...JSON.parse(elem.getAttribute('data-image-slider-modal') || '{}')
        }
        this._close = document.querySelectorAll(this._options.close)
        this._body = document.querySelectorAll(this._options.body)
        this._video = document.querySelectorAll(this._options.video)
        this._originalVidSrc = this._video.src
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._close = document.querySelectorAll(this._options.close)
        this._body = document.querySelector(this._options.body)
        this._video = document.querySelector(this._options.video)
        this._originalVidSrc = this._video ? this._video.src : ''

        this.setClickEvents()
    }

    setClickEvents () {
        console.log('setClickEvents', this._elem)
        this._elem.addEventListener('click', () => {
            this.openModal()
            this.autoPlay()
            this.videoOpacityVisible()
        })
        this._close.forEach(close => close.addEventListener('click', () => {
            this.closeModal()
            this.autoStop()
            this.videoOpacityNotVisible()
        }))
    }

    runEventMethods (methods) {
        methods.forEach(method => this[method]())
    }

    openModal () {
        this._body.classList.add(cssClasses.active)
    }

    autoPlay () {
        if (!this._video) return
        this._video.src += '?autoplay=1'
    }

    closeModal () {
        this._body.classList.remove(cssClasses.active)
    }

    autoStop () {
        if (!this._video) return
        this._video.src = this._originalVidSrc
    }

    videoOpacityVisible () {
        if (!this._video) return
        window.setTimeout(() => {
            this._video.style.opacity = 1
        }, 400)
    }

    videoOpacityNotVisible () {
        if (!this._video) return
        this._video.style.opacity = 0
    }

    // /**
    //  * Expose public interface.
    //  */
    // return Object.freeze({
    //   init,
    // })
}

export default ImageSliderModal



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ImageSliderModal.js